module.exports = __webpack_public_path__ + "static/media/noAccess.307e302e.svg";